function multiStepForm(element, args) {
    if (args === null || typeof args !== 'object' || $.isArray(args))
        throw " : Called with Invalid argument";

    var form = $(element);
    // var tabs = form.find('.tab');
    var tabs = form.find('.tab.main-step');
    
    var steps = form.find('.step');

    steps.each(function(i, e) {
        $(e).on('click', function(ev) {
            navigateTo(i);
        });
    });

    $('.mrk-prev-custom').click(function() {
        navigateTo(2);
        $('.mrk-next-btn .next').show();
        $('.mrk-prev-btn .previous').show();
        $('.mrk-prev-custom').hide();
        $('.mrk-next-custom').hide();
    });
    // $('[name="logo-type"]').change(function() {
    //     var index = Number($(this).attr('step'));
    //     navigateTo(index);
    //     $('.mrk-prev-btn .previous').hide();
    //     $('.mrk-next-btn .next').hide();
    //     $('.mrk-prev-custom').show();
    //     $('.mrk-next-custom').show();
    // });

    function navigateTo(i) {
        //Ak custom code
        if(i == 0){
            $('.mrk-product-csutomizer .mrk-steps-footer .bundle-main-step-btn').removeClass('hidden');
            $('.mrk-product-csutomizer .mrk-steps-footer .bundle-pro-inner-btn').addClass('hidden');
            // $('.mrk-product-csutomizer .mrk-product-steps .bundle_pro_steps_main').addClass('hidden');
            $('.mrk-product-csutomizer .mrk-product-steps .bundle_pro_steps_main .bundle_inner_step').removeClass('current');
            // window.mrknavigateTo(cur_index);
            let remainingNumber;
            let allActivePositions = document.querySelectorAll(".mrk-product-csutomizer .mrk-product-steps .bundle_products .bundle_pro").length;
            let allActiveDonePositions = document.querySelectorAll(".mrk-product-csutomizer .mrk-product-steps .bundle_products .bundle_pro.done").length;
            remainingNumber = Number(allActivePositions - allActiveDonePositions);

            if(allActivePositions == allActiveDonePositions){
              form.find('.next').removeClass('disabled');
            }else{
              form.find('.next').addClass('disabled');
            }
        }
        //Ak custom code


        // if(i == 2 && $('.mrk-step-2.current').length){
        //   if($('[name="mrk-main-logo-position"]:checked').length == 0 && $('[name="mrk-main-logo-position"]').length){
        //     alert('Select Position!');
        //     return;
        //   }
        //   if (
        //       ($('[name="bundleItem-1-position"]').length && $('[name="bundleItem-1-position"]:checked').length === 0) ||
        //       ($('[name="bundleItem-2-position"]').length && $('[name="bundleItem-2-position"]:checked').length === 0) ||
        //       ($('[name="bundleItem-3-position"]').length && $('[name="bundleItem-3-position"]:checked').length === 0)
        //   ){
        //     alert('Select Position!');
        //     return;
        //   }
        // }
        
        //Ak custom code
        if (i != 0) {
          $('.mrk-prev-btn .previous').show();
        }else{
            $('.mrk-prev-btn .previous').hide();
        }
        //Ak custom code

        if (i != 2) {
            $('.mrk-next-btn .next').show();
            // $('.mrk-prev-btn .previous').show();
            $('.mrk-prev-custom').hide();
            $('.mrk-next-custom').hide();
        }
        if(i == 2){
            form.find('.next').addClass('goToLogoPage');
        }else{
            form.find('.next').removeClass('goToLogoPage');
        }
        tabs.removeClass('current').eq(i).addClass('current');

        if (!i > 0){
            form.find('.previous').addClass('disabled');
            //Ak custom code
            form.find('.previous').addClass('hidden');
            //Ak custom code
        }
        else{
            form.find('.previous').removeClass('disabled');
            //Ak custom code
            form.find('.previous').removeClass('hidden');
            //Ak custom code
        }

        var atTheEnd = i >= tabs.length - 1;
        var secondLast = i >= tabs.length - 2 || i >= tabs.length - 3;
        if (atTheEnd){
            form.find('.next').hide();
            $('.bundle-main-step-btn .mrk-final-add-to-cart').show();
            // form.find('.mrk-final-add-to-cart').show();
        }
        else
        {
            form.find('.next').show();
            $('.bundle-main-step-btn .mrk-final-add-to-cart').hide();
            // form.find('.mrk-final-add-to-cart').hide();
        }
        if (atTheEnd || secondLast){
            // $('.mrk-steps-footer').addClass('mrk-disable-btn');
            // form.find('.mrk-add-another-logo-wrapper').show();
            if($('[name="logo-type"]:checked').val() == 'Text Logo' && $('#logoText').val() != ''){
              $('.mrk-steps-footer').removeClass('mrk-disable-btn');
            }else if($('[name="logo-type"]:checked').val() == 'Upload Your Logo' && $('.hiddenFileInput').val() != ''){
              $('.mrk-steps-footer').removeClass('mrk-disable-btn');
            }
        }else{
            $('.mrk-steps-footer').removeClass('mrk-disable-btn');
            // form.find('.mrk-add-another-logo-wrapper').hide();
        }
        form.find('.submit').toggle(atTheEnd);

        fixStepIndicator(curIndex());
        // if(i == 3 || i==4){
        //   var index = Number($('[name="logo-type"]:checked').attr('step'));
        //   $('.mrk-prev-btn .previous').hide();
        //   $('.mrk-next-btn .next').hide();
        //   $('.mrk-prev-custom').show();
        //   $('.mrk-next-custom').show();
        //   if(index == i){
        //     return
        //   }
        //   navigateTo(index);
          
        // }
    }
    $('.goToLogoPage').click(function(e) {
        e.preventDefault();
        $('[name="logo-type"]').trigger('change');
    });
    function curIndex() {
        return tabs.index(tabs.filter('.current'));
    }

    function fixStepIndicator(n) {
        steps.each(function(i, e) {
            i == n ? $(e).addClass('active') : $(e).removeClass('active');
        });
    }

    form.find('.previous').click(function() {
        navigateTo(curIndex() - 1);
    });

    form.find('.next').click(function() {
        if ('validations' in args && typeof args.validations === 'object' && !$.isArray(args.validations)) {
            if (!('noValidate' in args) || (typeof args.noValidate === 'boolean' && !args.noValidate)) {
                form.validate(args.validations);
                if (form.valid() == true) {
                    navigateTo(curIndex() + 1);
                    return true;
                }
                return false;
            }
        }
        navigateTo(curIndex() + 1);
    });

    form.find('.submit').on('click', function(e) {
        if (typeof args.beforeSubmit !== 'undefined' && typeof args.beforeSubmit !== 'function')
            args.beforeSubmit(form, this);

        if (typeof args.submit === 'undefined' || (typeof args.submit === 'boolean' && args.submit)) {
            form.submit();
        }
    });

    if (typeof args.defaultStep === 'number') {
        navigateTo(args.defaultStep);
    }
    window.mrknavigateTo = navigateTo;
}





// Ak-DD custom inner bundle steps for eachproducts
function multiStepFormbundleinner(element, args) {
    if (args === null || typeof args !== 'object' || $.isArray(args))
        throw " : Called with Invalid argument";

    var form = $(element);
    var tabs = form.find('.bundle_inner_step');
    var steps = form.find('.step');
    
    var next = $('.mrk-product-csutomizer .mrk-steps-footer .bundle-pro-inner-btn .next-bundle-btn');
    var previous = $('.mrk-product-csutomizer .mrk-steps-footer .bundle-pro-inner-btn .previous-bundle-btn');
    $(previous).removeClass('disabled');
    next.off('click');
    previous.off('click');




    steps.each(function(i, e) {
        $(e).on('click', function(ev) {
            navigateToInner(i);
        });
    });

    // $('.mrk-prev-custom').click(function() {
    //     navigateToInner(2);
    //     $('.mrk-next-btn .next').show();
    //     $('.mrk-prev-btn .previous').show();
    //     $('.mrk-prev-custom').hide();
    //     $('.mrk-next-custom').hide();
    // });
    // $('[name="logo-type"]').change(function() {
    //     var index = Number($(this).attr('step'));
    //     navigateToInner(index);
    //     $('.mrk-prev-btn .previous').hide();
    //     $('.mrk-next-btn .next').hide();
    //     $('.mrk-prev-custom').show();
    //     $('.mrk-next-custom').show();
    // });

    function navigateToInner(i) {
        // console.log('nav i',i)
        //Ak custom code
        if(i == 1){
        //   $('[name="same-logo"]:checked').prop('checked');
          $('.mrk-steps-footer-back-buttons-container').show();
          $('.mrk-steps-footer-back-buttons-container .back-to-first').removeClass('hidden');
          $('.bundle-pro-inner-btn').addClass('hidden');
        }else{
          $('.mrk-steps-footer-back-buttons-container .back-to-first').addClass('hidden');
        //   $('.mrk-steps-footer-back-buttons-container .back-to-second').addClass('hidden');
        }
        //End Ak custom code

        if(i == 2 && $('.mrk-step-2.current').length){
          if($('[name="mrk-main-logo-position"]:checked').length == 0 && $('[name="mrk-main-logo-position"]').length){
            return;
          }
          if (
              ($('[name="bundleItem-1-position"]').length && $('[name="bundleItem-1-position"]:checked').length === 0) ||
              ($('[name="bundleItem-2-position"]').length && $('[name="bundleItem-2-position"]:checked').length === 0) ||
              ($('[name="bundleItem-3-position"]').length && $('[name="bundleItem-3-position"]:checked').length === 0)
          ){
            return;
          }
        }
        if (i != 2) {
            $('.mrk-next-btn .next').show();
            $('.mrk-prev-btn .previous').show();
            $('.mrk-prev-custom').hide();
            $('.mrk-next-custom').hide();
        }
        if(i == 2){
            form.find('.next').addClass('goToLogoPage');
        }else{
            form.find('.next').removeClass('goToLogoPage');
        }
        tabs.removeClass('current').eq(i).addClass('current');

        if (!i > 0)
            form.find('.previous').addClass('disabled');
        else
            form.find('.previous').removeClass('disabled');

        var atTheEnd = i >= tabs.length - 1;
        var secondLast = i >= tabs.length - 2 || i >= tabs.length - 3;
        if (atTheEnd){
            form.find('.next').hide();
            form.find('.mrk-final-add-to-cart').show();
        }
        else
        {
            form.find('.next').show();
            form.find('.mrk-final-add-to-cart').hide();
        }
        if (atTheEnd || secondLast){
            $('.mrk-steps-footer').addClass('mrk-disable-btn');
            // form.find('.mrk-add-another-logo-wrapper').show();
            if($('[name="logo-type"]:checked').val() == 'Text Logo' && $('#logoText').val() != ''){
              $('.mrk-steps-footer').removeClass('mrk-disable-btn');
            }else if($('[name="logo-type"]:checked').val() == 'Upload Your Logo' && $('.hiddenFileInput').val() != ''){
              $('.mrk-steps-footer').removeClass('mrk-disable-btn');
            }
        }else{
            $('.mrk-steps-footer').removeClass('mrk-disable-btn');
            // form.find('.mrk-add-another-logo-wrapper').hide();
        }
        form.find('.submit').toggle(atTheEnd);

        fixStepIndicator(curIndex());
        if(i == 3 || i==4){
          var index = Number($('[name="logo-type"]:checked').attr('step'));
          $('.mrk-prev-btn .previous').hide();
          $('.mrk-next-btn .next').hide();
          $('.mrk-prev-custom').show();
          $('.mrk-next-custom').show();
          if(index == i){
            return
          }
          navigateToInner(index);
          
        }
    }
    $('.goToLogoPage').click(function(e) {
        e.preventDefault();
        $('[name="logo-type"]').trigger('change');
    });
    function curIndex() {
        return tabs.index(tabs.filter('.current'));
    }

    function fixStepIndicator(n) {
        steps.each(function(i, e) {
            i == n ? $(e).addClass('active') : $(e).removeClass('active');
        });
    }

    // form.find('.previous').click(function() {
    //     navigateToInner(curIndex() - 1);
    // });
    $(previous).click(function() {
        // navigateToInner(curIndex() - 1);
        // console.log('index',curIndex());
        var cur_index = curIndex();
        if(cur_index == 0){
            $('.mrk-product-csutomizer .mrk-steps-footer .bundle-main-step-btn').removeClass('hidden');
            $('.mrk-product-csutomizer .mrk-steps-footer .bundle-pro-inner-btn').addClass('hidden');
            $('.mrk-product-csutomizer .mrk-product-steps .bundle_pro_steps_main').addClass('hidden');
            $('.mrk-product-csutomizer .mrk-product-steps .bundle_pro_steps_main .bundle_inner_step').removeClass('current');
            window.mrknavigateTo(cur_index);
        }else{
             navigateToInner(curIndex() - 1);
        }
    });

    $(next).click(function() {
    // form.find('.next').click(function() {
        if ('validations' in args && typeof args.validations === 'object' && !$.isArray(args.validations)) {
            if (!('noValidate' in args) || (typeof args.noValidate === 'boolean' && !args.noValidate)) {
                form.validate(args.validations);
                if (form.valid() == true) {
                    navigateToInner(curIndex() + 1);
                    return true;
                }
                return false;
            }
        }        
        // console.log('curIndex',curIndex())
        navigateToInner(curIndex() + 1);
    });

    form.find('.submit').on('click', function(e) {
        if (typeof args.beforeSubmit !== 'undefined' && typeof args.beforeSubmit !== 'function')
            args.beforeSubmit(form, this);

        if (typeof args.submit === 'undefined' || (typeof args.submit === 'boolean' && args.submit)) {
            form.submit();
        }
    });

    if (typeof args.defaultStep === 'number') {
        navigateToInner(args.defaultStep);
    }

    window.mrknavigateToInner = navigateToInner;
}
// Ak-DD custom inner bundle steps for eachproducts